module.exports = __webpack_public_path__ + "img/location.33393037.svg";